import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';

import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import messages from '../../messages';
import { SIMILAR_OPTIONS_REASONS, INACTIVE, INCOMPLETE_ADDRESS } from '../constants';
import style from './preview-modal.module.less';

export const RateStatusIndicator = ({ rate }) => {
  const { isIncluded, excludedReason } = rate;

  if (isIncluded) {
    return (
      <div className={style['status-indicator']}>
        <FontAwesomeIcon className={style['check-icon']} icon={faCheck} />
        <FormattedMessage {...messages.activeStatus} />
      </div>
    );
  }

  let statusLabel = <FormattedMessage {...messages.noRate} />;
  let statusDescription = <FormattedMessage {...messages.noRateDescription} />;
  if (SIMILAR_OPTIONS_REASONS.includes(excludedReason)) {
    statusLabel = <FormattedMessage {...messages.similarOptions} />;
    statusDescription = <FormattedMessage {...messages.similarOptionsDescription} />;
  }
  if (excludedReason === INACTIVE) {
    statusLabel = <FormattedMessage {...messages.inactiveStatus} />;
    statusDescription = <FormattedMessage {...messages.inactiveDescriptionCR} />;
  }
  if (excludedReason === INCOMPLETE_ADDRESS) {
    statusLabel = <FormattedMessage {...messages.incompleteAddress} />;
    statusDescription = <FormattedMessage {...messages.fullAddressRequiredDescription} />;
  }
  return (
    <Tooltip>
      <div className={style['status-indicator']}>
        <FontAwesomeIcon className={style['hidden-icon']} icon={faEyeSlash} />
        {statusLabel}
      </div>
      <TooltipContent>{statusDescription}</TooltipContent>
    </Tooltip>
  );
};

RateStatusIndicator.propTypes = {
  rate: PropTypes.shape({
    isIncluded: PropTypes.bool,
    excludedReason: PropTypes.string,
  }).isRequired,
};
